import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-error\">\r\n  <defs>\r\n    <style>\r\n      #icon-error .cls-1 {\r\n        fill: #4cb2ff;\r\n      }\r\n\r\n      #icon-error .cls-2 {\r\n        fill: #f76958;\r\n        opacity: 0;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <g id=\"icon-error_组_353\" data-name=\"组 353\" transform=\"translate(-314 -1118)\">\r\n    <path id=\"icon-error_Shape\" class=\"cls-1\" d=\"M9.838,8l5.973,5.973a.651.651,0,0,1,0,.919l-.919.919a.651.651,0,0,1-.919,0L8,9.838,2.028,15.81a.651.651,0,0,1-.919,0L.19,14.891a.65.65,0,0,1,0-.919L6.162,8,.19,2.028a.65.65,0,0,1,0-.919L1.109.19a.65.65,0,0,1,.919,0L8,6.162,13.972.19a.65.65,0,0,1,.919,0l.919.919a.651.651,0,0,1,0,.919L9.838,8Z\" transform=\"translate(317 1121)\" />\r\n    <rect id=\"icon-error_矩形_440\" data-name=\"矩形 440\" class=\"cls-2\" width=\"22\" height=\"22\" transform=\"translate(314 1118)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/error.svg
// module id = KCO8
// module chunks = 3